"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entityExportQuery = void 0;
var client_1 = require("@apollo/client");
var entityExportQuery = function (definition, context) {
  var _a = context.queryName,
    queryName = _a === void 0 ? '' : _a,
    _b = context.queryFields,
    queryFields = _b === void 0 ? '' : _b,
    entities = context.entities;
  return !queryName && definition.details.query || (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ", " {\n      all", " {\n        id\n        name\n        ", "\n      }\n    }\n  "], ["\n    query ", " {\n      all", " {\n        id\n        name\n        ", "\n      }\n    }\n  "])), queryName || "".concat(definition.typeName, "ExportQuery"), definition.pluralName, definition.export.queryFields || '');
};
exports.entityExportQuery = entityExportQuery;
var templateObject_1;